export const downloadFile = (fileUrl: string, fileName: string = 'archivo.pdf') => {
  const link = document.createElement('a');
  link.href = fileUrl;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};